import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import _ from "lodash"
import Actions from '../../../appFlux/action'
import DatePicker from "react-datepicker";
import DateInput from '../../../common/DateInput'

class EditMyIntroModal extends React.Component {
    constructor(props) {
        super(props);
        // Don't call this.setState() here!
        var { modal, toggle, basic } = props
        console.log(basic, "basic")
        this.state = {
            basicFields: _.cloneDeep(basic),
            error: {}
        }
    }
    componentWillReceiveProps(){
        this.setState({error: []})
    }

    render(){
        var { modal, toggle, basic } = this.props
        var {basicFields, error} = this.state
        const editBasicFields = (value, param) => {
            basicFields[param] = value
            this.setState({basicFields})
        }
        const validate = () => {
            var error = {}
            if (!basic.city) error.city = true
            if (!basic.country) error.country = true
            if (!basic.email) error.email = true
            // if (!basic.phone) error.phone = true
            if(_.keys(error).length === 0) return true
            else this.setState({error})
        }
        const reset = () => this.setState({basicFields: _.cloneDeep(basic)})
        const save = () => {
            basic = basicFields
            if(validate() === true){
                Actions.setBasicFields(basic)
                toggle()
            }
        }
        const getClass = (className, check) => className + (check ? " bo-error": "")
        console.log(getClass("form-control", error.city))
        return (
            <Modal isOpen={modal} toggle={toggle}  className="modal-wrap wd-700"> 
            {/* wd-x , x works from 0 to 1000 in multiples of 10. so other widths please make class  */}
                <div className="d-flex pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
                    <div className="modal-header">Edit Introduction</div>
                    <div className="v-align f-right" style={{marginLeft:'auto'}}>
                        <i className="fa fa-cog modal-close mg-r-15" ></i> 
                        <i className="far fa-question-circle modal-close mg-r-15" ></i>
                        <i className="fas fa-times modal-close" onClick={toggle}></i>
                    </div>
                </div>   
                <hr className="mg-r-0"></hr>
                <div className="modal-block">
                    <div className="row mg-b-15">
                        <div className="col-md-6">
                            <div className="modal-subheader">First Name
                            <span className="mandatory-field">*</span>
                            </div>
                            <div><input type="text" disabled className="form-control" value={basicFields.fName} onChange={(e) => editBasicFields(e.target.value, "fName")}></input></div>
                        </div>
                        <div className="col-md-6">
                            <div className="modal-subheader">Last Name
                            <span className="mandatory-field">*</span></div>
                            <div><input type="text" disabled className="form-control" value={basicFields.sName} onChange={(e) => editBasicFields(e.target.value, "sName")}></input></div>
                        </div>
                    </div>
                    <div className="row mg-b-15">
                        <div className="col-md-6">
                        <div className="modal-subheader">Headline</div>
                            <div><input type="text" className="form-control" value={basicFields.headline} onChange={(e) => editBasicFields(e.target.value, "headline")}></input></div>
                        </div>   
                        <div className="col-md-6">
                            <div className="modal-subheader">Date of Birth
                                <span className="mandatory-field">*</span>
                            </div>
                            <DatePicker
                                selected={basicFields.dob}
                                onChange={(e) => editBasicFields(e, "dob")}
                                customInput={<DateInput />}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                            />
                        </div>             
                    </div>
                    <div className="row mg-b-15">
                        <div className="col-md-6">
                            <div className="modal-subheader">City/State
                            <span className="mandatory-field">*</span></div>
                            <div><input type="text" className={getClass("form-control", error.city)} value={basicFields.city} onChange={(e) => editBasicFields(e.target.value, "city")}></input></div>
                        </div>
                        <div className="col-md-6">
                            <div className="modal-subheader">Country
                            <span className="mandatory-field">*</span></div>
                            <div><input type="text" className={getClass("form-control", error.country)} value={basicFields.country} onChange={(e) => editBasicFields(e.target.value, "country")}></input></div>
                        </div>
                    </div>            
                    <div className="modal-subheader">Cover Message</div>
                    <div>
                        <textarea className="textarea" style={{marginTop:'0px', marginBottom:'0px', height:'153px'}} value={basicFields.coverMsg} onChange={(e) => editBasicFields(e.target.value, "coverMsg")}></textarea>
                    </div>             
                </div>  
                {_.keys(error).length > 0 ?(
                <div className="error-display">
                    Please fill the mandatory fields, marked in red.
                </div>
                ):null}
                <hr className="mg-0 "></hr>
                <div className="pd-20 box-shadow-top">          
                    <button className="btn btn-primary-lite f-right mg-r-15" onClick={save}>Save</button>
                    <button className="btn btn-success-lite mg-r-15 f-right" onClick={reset}>Reset</button>    
                    <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>           
                </div>
                        
            </Modal>
        )
    }
}
export default EditMyIntroModal;